module.exports = __webpack_public_path__ + "static/media/HIFIVE.f12c7156.png";